import { ApiSimpleComponent } from "@incendium/api";
import { Editor, ProjectData, StorageOptions } from "grapesjs";
import debounce from "lodash/debounce";

export const customOnEditor = (
  editor: Editor,
  component: ApiSimpleComponent,
  saveComponent: (
    editor: any
  ) => (data: ProjectData, options: StorageOptions) => any
) => {
  editor.StorageManager.add("custom", {
    load() {
      // Use the component data that's already loaded instead of making an API call
      let data = {};

      if (component?.grapeJs && component.grapeJs !== "") {
        try {
          data = JSON.parse(component.grapeJs);
        } catch (error) {
          // console.error("Error parsing grapeJs data:", error);
          // If parsing fails, fall back to empty data
          data = {};
        }
      }

      return Promise.resolve(data);
    },
    store: saveComponent(editor),
  });

  // Show borders by default
  // editor.Panels.getButton("options", "sw-visibility")?.set("active", 1);
  editor.runCommand("core:component-outline");

  // Insert default button CSS only once when a button is added, using CssComposer for GrapesJS management
  const defaultButtonCss = `
.inc-button {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  transition: background 0.2s, color 0.2s;
}
.inc-button-primary {
  background: var(--primary-color);
  color: #fff;
}
.inc-button-secondary {
  background: var(--secondary-color);
  color: #fff;
}
`;

  const injectBtnCssIfNeeded = (model: any) => {
    const cssc = editor.CssComposer;
    if (cssc.getRule(".inc-button")) return;
    const hasIncButton = (editor.getWrapper()?.find(".inc-button")?.length ?? 0) > 0;
    const classes = model?.get?.("classes");
    const classNames: string[] = classes?.map((c: any) => c.get("name")) ?? [];
    if (!hasIncButton && !classNames.includes("inc-button")) return;
    cssc.addRules(defaultButtonCss);
  };

  const debouncedInjectBtnCss = debounce(injectBtnCssIfNeeded, 150);
  editor.on("component:add", (model: any) => debouncedInjectBtnCss(model));

  return editor;
};
